import { render, staticRenderFns } from "./frontReferenciasForm.vue?vue&type=template&id=28864375&scoped=true&"
import script from "./frontReferenciasForm.vue?vue&type=script&lang=js&"
export * from "./frontReferenciasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28864375",
  null
  
)

export default component.exports